import { render } from "./VentaPOS.vue?vue&type=template&id=2176ec51&scoped=true"
import script from "./VentaPOS.vue?vue&type=script&lang=js"
export * from "./VentaPOS.vue?vue&type=script&lang=js"

import "./VentaPOS.vue?vue&type=style&index=0&id=2176ec51&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2176ec51"]])

export default __exports__